<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="#" action="#">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->

          <card>
            <div slot="header">
              <img
                src="static/img/centralized-data.png"
                style="max-width: 200px; width: 100%; display: block; margin: auto; margin-bottom: 50px;"
              />
              <span class="card-title text-center" style="font-family: 'Comfortaa', cursive;">
                Redirecting you the Fiifi page
                <span class="spinnerdot">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </span>
              </span>
            </div>
            <div></div>
          </card>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "./AuthLayout.vue";
export default {
  components: {
    AuthLayout
  },
  data() {
    return {};
  },
  mounted() {
    let self = this;
    let invitedEmail = window.atob(self.$route.params.invitedEmail);
    let uuid = window.atob(self.$route.params.uuid);
    let role_id = window.atob(self.$route.params.role_id);
    if (localStorage.getItem("fiifi") && JSON.parse(localStorage.fiifi).user.server_id.length > 0) {
      let signedUser = JSON.parse(localStorage.getItem("fiifi")).user;
      let email =
        signedUser.linkedin.email ||
        signedUser.google.email ||
        signedUser.twitter.email ||
        signedUser.facebook.email ||
        signedUser.cognito.email ||
        "";
      if (
        signedUser.token.length > 1 &&
        signedUser.server_id.length > 1 &&
        email == invitedEmail
      )
        this.$router.push("/");
      else
        this.$router.push(
          `/login?by=${btoa(uuid)}&role=${btoa(role_id)}&email=${btoa(
            invitedEmail
          )}`
        );
    } else
      this.$router.push(
        `/login?by=${btoa(uuid)}&role=${btoa(role_id)}&email=${btoa(
          invitedEmail
        )}`
      );
  }
};
</script>
<style>
/*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */
.spinnerdot {
  width: 70px;
  text-align: center;
}

.spinnerdot > div {
  width: 11px;
  height: 11px;
  background-color: #333;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinnerdot .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinnerdot .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>

